import { MoreOutlined, ArrowLeftOutlined } from '@ant-design/icons';
import { Dropdown, MenuProps } from 'antd';
import style from './index.module.scss';
import { useNavigate } from 'react-router-dom';
import { useCallback } from 'react';
import { useAuth } from 'hooks/useAuth';

type THeader = {
  title: string;
  allowBack?: boolean;
};

export const Header = ({ title, allowBack }: THeader) => {
  const { signOut } = useAuth();
  const navigation = useNavigate();

  const navBack = useCallback(() => {
    navigation(-1);
  }, [navigation]);

  return (
    <div className={style.header}>
      {allowBack && (
        <ArrowLeftOutlined className={style.backbutton} onClick={navBack} />
      )}
      <p>{title}</p>
      <Dropdown
        menu={{
          items: [
            {
              key: '1',
              label: 'Cerrar Session',
              onClick: signOut,
            },
          ],
        }}
        placement="bottomRight"
      >
        <MoreOutlined className={style.logout} />
      </Dropdown>
    </div>
  );
};
